import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { ProspectorDataProvider } from "../../data-provider/prospector.dp";
import { Campaign } from "../../models/campaign.model";

let ProspectorChangeStateDialogComponent = {
    selector: "vcProspectorChangeStateDialog",
    templateUrl:
        "/angular/components/prospector/prospector-change-state-dialog.component.html",
    bindings: {
        center: "=?",
    },
    controller: class ProspectorChangeStateDialogController {
        private dialog: DialogUtils;
        private activeCampaign: Campaign;
        private dataProvider: ProspectorDataProvider;
        public states: { name: string; abbreviation: string }[];
        public selectedState: string;
        public campaignDataProvider: CampaignDataProvider;
        public center: any;
        public loading: boolean = true;

        constructor(
            DialogUtils: DialogUtils,
            ProspectorDataProvider: ProspectorDataProvider,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.dialog = DialogUtils;
            this.dataProvider = ProspectorDataProvider;
            this.selectedState = ProspectorDataProvider.getSelectedState();
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.campaignDataProvider = CampaignDataProvider;
            this.states = this.dataProvider.getStates();

            this.activeCampaign.getLocalStorage();
        }

        $onInit() {
            if (!this.activeCampaign.localInfo.us_state) {
                this.dataProvider.getSuggestedState(this.center).then(
                    (state: any): void => {
                        if (state && state.abbreviation) {
                            this.selectedState = state.abbreviation;
                            this.stateChanged();
                            this.loading = false;
                        } else {
                            this.campaignDataProvider.ipInfo().then(
                                (data): void => {
                                    this.loading = false;
                                    if (data.region) {
                                        angular.forEach(
                                            this.states,
                                            (state) => {
                                                if (state.name == data.region) {
                                                    this.selectedState =
                                                        state.abbreviation;
                                                    this.stateChanged();
                                                }
                                            }
                                        );
                                    }
                                },
                                () => {
                                    this.loading = false;
                                }
                            );
                        }
                    },
                    () => {
                        this.loading = false;
                    }
                );
            } else {
                this.loading = false;
            }
        }

        stateChanged(): void {
            this.dataProvider.setSelectedState(this.selectedState);
        }

        confirm(): void {
            this.dialog.hide();
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("dashboard")
    .component(
        ProspectorChangeStateDialogComponent.selector,
        ProspectorChangeStateDialogComponent
    );
